/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React from 'react';
import { css, jsx } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import { AtlassianIcon } from '@atlaskit/logo';

interface Props {
	avatarUrl: string | null;
	alt?: string;
}

interface State {
	imageLoadFailed: boolean;
}

const imageStyles = css({
	width: token('space.300', '24px'),
	height: token('space.300', '24px'),
	marginTop: token('space.050', '4px'),
	marginRight: token('space.050', '4px'),
	marginBottom: token('space.050', '4px'),
	marginLeft: token('space.050', '4px'),
	borderRadius: token('border.radius', '3px'),
});

const containerStyles = css({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	overflow: 'hidden',
});

export default class Avatar extends React.Component<Props, State> {
	state = {
		imageLoadFailed: false,
	};

	render() {
		const { avatarUrl, alt } = this.props;
		return (
			<div css={containerStyles}>
				{(!avatarUrl || this.state.imageLoadFailed) && <AtlassianIcon size="medium" />}
				{avatarUrl && !this.state.imageLoadFailed && (
					<img alt={alt} css={imageStyles} src={avatarUrl} onError={this.onError} />
				)}
			</div>
		);
	}

	private onError = () => {
		this.setState({ imageLoadFailed: true });
	};
}
